export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref13162.7b4214a2.jpg";